














































import Vue from 'vue';
import Component from 'vue-class-component';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import Box from '@/components/Box.vue';
import { namespace } from 'vuex-class';
import { UserUpdate } from '@sone/sone-frontend-core/src/models/UserUpdate';

const codeValidate = (value: any) => {
  return /^[0-9]{1,6}$/.test(value);
};
const oidcStore = namespace('oidc');

@Component({
  components: {
    Box,
  },
  layout: 'unauthenticated',
  mixins: [validationMixin],
  validations: {
    form: {
      code: { required, codeValidate },
    },
  },
})
export default class ValidateMfaPage extends Vue {
  public form = { code: null, secret: null, counter: 1,
    userId: '00000000-0000-0000-0000-000000000000', phoneNumber: null,
    email: null, origin: null
  };
  public error: any = false;
  public invalidCode = false;
  public action = '';
  public errorLogin = false;
  public loading = false;
  public success = false;
  public returnUrl: string | string[] = '';
  public registerEmail: string | string[] = '';
  public registerPhone: string | string[] = '';
  public authenticateOidc!: () => {};

  public created() {
    if (this.$route && this.$route.query) {
      this.form.secret = this.$route.query.secret;
      this.returnUrl = this.$route.query.returnUrl;
      this.registerEmail = this.$route.query.registerEmail;
      this.registerPhone = this.$route.query.registerPhone;
      this.form.userId = this.$route.query.user as string;
      this.form.origin = this.$route.query.origin as string;

      if( this.form.origin === 'register'){
        this.form.userId = localStorage.getItem('userId');
        this.form.email = localStorage.getItem('email');
        this.form.phoneNumber = localStorage.getItem('phone');
      }

      if (this.$route.query.error) {
        this.errorLogin = (this.$route.query.error === 'invalid_login')
          || (this.$route.query.error === 'blocked_login');
      }
    }

    if (!this.$route.query.returnUrl) {
      return this.authenticateOidc();
    }

    this.action = `${process.env.VUE_APP_AUTH_URL}api/v1/hotp/validate?&returnUrl=${encodeURIComponent((this.$route.query.returnUrl as string))}&api-version=1.0`;
  }

  public getValidationClass(fieldName: string) {
    const field = (this.$v.form as any)[fieldName];
    if (field) {
      return {
        'md-invalid': field.$invalid && field.$dirty,
      };
    }
  }

  public replaceEmailMessage(message, registerEmail){
    message = message.replace("{email}", registerEmail);
    return message;
  }

  public replacePhoneMessage(message, registerPhone){
    message = message.replace("{celular}", registerPhone);
    return message;
  }

  public validateMfa(event: any) {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      localStorage.removeItem('user');
      localStorage.removeItem('userId');
      this.loading = true;
      return true;
    } else {
      event.preventDefault();
    }
  }
}
